<template>
  <section>
    <div class="mui-content0">
      <div class="main" style="">
        <div style="margin:15px 0px;text-align: center;">
          <div class="icon iconfont icon-top" @click="changeM(-1)">&#xe7b1;</div>
          <div class="date-top" style="display:inline-block;margin:0px 28px;">{{timeValue}}</div>
          <div class="icon iconfont icon-top" @click="changeM(1)"> &#xe7b2;</div>
        </div>
        <div class="date-row" style=" margin-bottom: 0px;height:20px;">
          <div class="date-block-top" v-for="(h, i) in teheadList" :key="i">{{h}}</div>
        </div>
        <div class="date-row" v-for="(b, i) in tbodyList" :key="i" v-show="!b.hide">
          <div v-for="(o, index) in b.cols" :key="index" @click="selectDate(o)">
            <div v-if="o.isToday" :class="o.active ?'active':'today' ">今</div>
            <div :class="o.active ?'active':o.class " v-else>{{o.name}}</div>

            <div :class="o.hasData?'hasdata':''"></div>
          </div>
        </div>
        <div class="icon iconfont icon-bottom" @click="expandcollapse()"> &#xe7b6;</div>
      </div>
    </div>
  </section>
</template>
<script>


export default {
  name: 'NyyDatePicker',
  props: {
    changeDate: {
      type: Function
    },
    changeMonth: {
      type: Function
    }
  },
  data () {
    return {
      timeValue: '',
      teheadList: ['日', '一', '二', '三', '四', '五', '六'],
      year: '',
      month: 0,
      day: '',
      tbodyList: [],
      dateList: [],
      currentDay: '',
      dispflg: true,
      toDay: '',
      currentItem: {},
      monthChangeSelectedItem:{}
    };
  },
  created () {

  },
  computed: {

  },
  mounted () {
    this.getInitTime();
  },
  watch: {
    month () {
      var v = this;
      if (v.month < 1) {
        v.month = 12;
        v.year--;
      } else if (v.month > 12) {
        v.month = 1;
        v.year++;
      }
      v.tbodyList = [];
      v.timeValue = v.year + '年' + v.month + '月' + v.day + '日';
      v.handleAetCalendar(function () {
        var startDate, endDate;
        if (v.tbodyList && v.tbodyList.length > 0) {
          startDate = v.getFormatDate(v.tbodyList[0].cols[0]);
          // startDate = v.getFormatDate(v.tbodyList[4].cols[6]);
          endDate = v.getFormatDate(v.tbodyList[v.tbodyList.length -1].cols[v.tbodyList[v.tbodyList.length -1].cols.length - 1]);
        }
        v.selectDate(v.monthChangeSelectedItem);

        v.$emit('changeMonth', startDate, endDate, function (dateList) {
          v.dateList = dateList;
          v.setHasData();
          // if(v.currentItem != v.monthChangeSelectedItem){
          //   v.$emit('changeDate', v.getFormatDate(v.monthChangeSelectedItem));
          // }
        });
      });
    },
    currentItem () {
      this.$emit('changeDate', this.getFormatDate(this.currentItem));
    }
  },
  methods: {
    //改变月份
    changeM (data) {
      var v = this;
      v.month += data;


    },
    //设置当天是否有数据
    setHasData () {
      var v = this;
      if (!v.dateList) return;
      for (var i = 0; i < v.dateList.length; i++) {
        var date = v.dateList[i];
        if (date) {
          var dateArr = date.split("/");
          var year = dateArr[0];
          var month = dateArr[1];
          var day = dateArr[2];
          v.tbodyList.forEach(item => {
            item.cols.forEach(sitem => {
              if (Number(year) == Number(sitem.year) && Number(month) == Number(sitem.month) && (day) == Number(sitem.name)) {
                sitem.hasData = true;
              }
            })
          })
        }
      }
      v.$forceUpdate();
    },
    //初始化时间
    getInitTime () {
      let date = new Date();
      this.year = date.getFullYear(); // 获取当年
      this.month = date.getMonth() + 1; // 获取本月
      this.day = date.getDate(); // 获取当天
      this.timeValue = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDay() + '日';

      this.currentDay = this.year + '/' + this.month + '/' + this.day;
      this.toDay = new Date(this.year + '/' + this.month + '/' + this.day);
      this.handleAetCalendar();
    },
    hasTask (dt) {

    },
    // 生成当月期数据
    handleAetCalendar (callback) {

      this.tbodyList = [];
      let days = new Date(this.year, this.month, 0).getDate(); // 当月总天数
      let week = new Date(this.year, this.month - 1, 1).getDay(); // 当月有几周
      let last_month = new Date(this.year, this.month - 1, 0).getDate(); // 当月的上一个月的最后一天
      this.tbodyList = [];
      for (let i = 0; i < Math.ceil((days + week) / 7) * 7; i++) {
        let nub = Math.floor(i / 7);
        let o;

        if (!this.tbodyList[nub]) {
          this.tbodyList[nub] = { hide: false, cols: [] };
        }

        if (i < week) {
          o = {
            class: 'date-block-pre',
            name: last_month + i - week + 1,
            month: this.month == 0 ? 12 : this.month - 1,
            year: this.month == 1 ? this.year - 1 : this.year,
            active: false,
            hasData: false,
          };

          let dayStr = o.year + '年' + o.month + '月' + o.name + '日';
          if(dayStr == this.timeValue){
            o.active = true;
            this.monthChangeSelectedItem = o;
          }

          this.tbodyList[nub].cols.push(o);
        } else {
          let day = i - week + 1;
          let className = 'date-block';
          let month = this.month;
          let year = this.year;
          if (day > days) {
            day -= days;
            className = 'date-block-pre';
            month = this.month + 1 > 12 ? 1 : this.month + 1;
            year = this.month + 1 > 12 ? this.year + 1 : this.year;

          }
          o = {
            class: className,
            name: day,
            month: month,
            year: year,
            active: false,
            hasData: false,
          }

          let dayStr = o.year + '年' + o.month + '月' + o.name + '日';
          if(dayStr == this.timeValue){
            o.active = true;
            this.monthChangeSelectedItem = o;
          }

          this.tbodyList[nub].cols.push(o);
        }
        o.isToday = (o.year == this.toDay.getFullYear() && o.month == (this.toDay.getMonth() + 1) && o.name == this.toDay.getDate());

        if (o.isToday) {
          this.currentItem = o;
          //break;
        }


        //if(o.year==this.toDay.getFullYear()&&o.month==(this.toDay.getMonth()+1)&&(o.name==this.toDay.getDate()+3))o.hasData=true;
      }
      let r = this.tbodyList[Math.floor((week + days) / 7)];
      if (r) {
        let arr = this.tbodyList[Math.floor((week + days) / 7)].cols;

        if (arr && arr.length !== 7) {
          this.tbodyList[Math.floor((week + days) / 7)].cols = arr.concat(
            new Array(7 - arr.length).fill(''));
        }
      }
      if(callback) callback();
    },
    //处理当前点击时间
    selectDate (item) {
      let newVal = `${item.year}/${item.month}/${item.name}`;
      this.timeValue = item.year + '年' + item.month + '月' + item.name + '日';
      this.currentDay = newVal;
      this.currentItem.active = false;
      this.currentItem = item;
      this.currentItem.active = true;
    },
    expandcollapse () { // 展开

      let v = this;
      v.dispflg = !v.dispflg;
      if (v.dispflg) {
        for (var i = 0; i < v.tbodyList.length; i++) {
          v.tbodyList[i].hide = false;
        }
      } else {
        for (var i = 0; i < v.tbodyList.length; i++) {
          v.tbodyList[i].hide = true;
          var weekInfo = v.tbodyList[i].cols;
          for (var j = 0; j < weekInfo.length; j++) {
            if (weekInfo[j] == v.currentItem) {
              v.tbodyList[i].hide = false;
              break;
            }
          }
        }
      }
      v.$forceUpdate();
    },
    getFormatDate (item) {
      var seperator1 = "/";
      var year = item.year;
      var month = item.month;
      var strDate = item.name;
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
  }
}
</script>

<style scoped>
.date-row {
  height: 28px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin: 12px 28px;
}
.date-top {
  font-size: 15px;
  text-align: center;
  color: #191919;
  margin: 15px auto;
  font-weight: 500;
}
.date-block-top {
  height: 20px;
  width: 28px;
  color: #888892;
  font-size: 12px;
  text-align: center;
}
.date-block {
  height: 28px;
  width: 28px;
  color: #505050;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  line-height: 28px;
}
.active {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background-color: #2f86f3;
  color: #fdfdff;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  line-height: 28px;
}
.today {
  height: 28px;
  width: 28px;
  border-radius: 50%;
  background-color: #ebeff5;
  color: #2f86f3;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  line-height: 28px;
}
.date-block-pre {
  height: 28px;
  width: 28px;
  color: #cbcbcb;
  font-size: 13px;
  font-weight: bold;
  text-align: center;
  line-height: 28px;
}
.main {
  font-family: "Microsoft YaHei", "苹方";
  box-shadow: 0px 0px 10px #455ca733;
  margin-top: -20px;
}
.hasdata {
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: #2f86f3;
  margin: 4px auto;
}
.icon-top {
  display: inline-block;
  font-size: 18px;
  color: #2f86f3;
  padding-top: 10px;
}
.icon-bottom {
  font-size: 1px;
  color: #d2d7dc;
  margin-top: -10px;
  text-align: center;
}
.mui-content0 {
  font-size: 12px;
  background-color: #ffffff;
  top: 0px;

  left: 0;
  right: 0;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/datesSelect.vue